<template>
<div id="proyectos" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-row align-center justify-center>
            <v-col xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar Proyectos" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                       <v-spacer></v-spacer>
                       <exportar-excel :data="datafiltered" :exportFields="camposexcel" name="Proyectos.xlsx" >
                            <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                <v-icon dark>get_app</v-icon>
                            </v-btn>
                        </exportar-excel>                        
                        &nbsp;
                        <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="registros" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="getRegistro(props.row.id_proyecto)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="
                          deleteRegistro(props.row.id_proyecto)
                        " title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-col>
        </v-row>
    </v-container>

    <v-dialog v-model="modal" max-width="70%" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon @click.native="modal = false" class="white--text" >cancel</v-icon>
                    <span class="subheading" >
                        <strong>{{ update ? "Actualizar" : "Nuevo" }} Proyecto</strong>
                    </span>
                </v-card>
            </v-card-title>
            <v-form ref="form" lazy-validation>
                <v-card-text>
                    <v-container grid-list-md text-xs-center>
                        <v-row row wrap>
                            <v-col xs="12" sm="6" md="6" lg="6">
                                <v-text-field v-model="model.nombre_proyecto" label="Nombre del Proyecto" 
                                    :rules="[rules.required]" maxlength="250">
                                    </v-text-field>
                            </v-col>
                            <v-col xs="12" sm="6" md="6" lg="6">
                                <v-autocomplete :items="clientes" v-model="model.cliente" label="Seleccione RFC o TAX ID" 
                                :item-text="getNombreCliente" item-value="id_cliente" :rules="[rules.required]" 
                                @change="getUsuariosCliente()"
                                :loading="loadingclientes"></v-autocomplete>                                
                            </v-col>                            
                        </v-row>                        
                        <v-row row wrap>
                            <v-col>
                                <v-textarea label="Notas" outlined rows="10" v-model="model.notas" :rules="[rules.required]" ></v-textarea>
                            </v-col>                            
                        </v-row>
                        <v-row row wrap>
                            <v-col xs="12" sm="3" md="3" lg="3">
                                <v-autocomplete :items="usuarios_super" v-model="model.usuario_asignado" label="Ticket Asignado a" 
                                :item-text="getNombreUsuario" item-value="id_usuario" :rules="[rules.required]":loading="loadingusers" ></v-autocomplete>         
                            </v-col>                                                        
                            <v-col xs="12" sm="3" md="3" lg="3">
                                <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" >
                                    <template v-slot:activator="{ on }" >
                                        <v-text-field v-on="on" v-model="model.fecha_inicial" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_inicial = parseDate(model.fecha_inicial)" v-mask="'####-##-##'" 
                                        :rules="[validaDias, validaFecha]" >
                                        </v-text-field>
                                    </template>

                                    <v-date-picker v-model="model.fecha_inicial" color="secondary"  scrollable locale="es-mx" @input="menu1 = false" >
                                        <v-spacer />

                                        <v-btn color="secondary" x-small @click="menu1 = false" >
                                        Cancelar
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col xs="12" sm="3" md="3" lg="3">
                                <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" >
                                    <template v-slot:activator="{ on }" >
                                        <v-text-field v-on="on" v-model="model.fecha_cierre" label="Fecha Cierre" color="secondary" prepend-icon="event" @blur="model.fecha_cierre = parseDate(model.fecha_cierre)" v-mask="'####-##-##'" 
                                        :rules="[validaDias, validaFecha]" >
                                        </v-text-field>
                                    </template>

                                    <v-date-picker v-model="model.fecha_cierre" color="secondary"  scrollable locale="es-mx" @input="menu2 = false" >
                                        <v-spacer />

                                        <v-btn color="secondary" x-small @click="menu2 = false" >
                                        Cancelar
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>                            
                        </v-row>   
                        <v-row row wrap>
                            <v-col xs="12" sm="3" md="3" lg="3">
                                <v-autocomplete :items="arr_estatus" v-model="model.estatus" label="Estatus" 
                                :rules="[rules.required]" ></v-autocomplete>
                            </v-col>
                            <v-col xs="12" sm="6" md="6" lg="6">
                                 <v-slider
                                    v-model="model.avance"
                                    :min="0"
                                    :max="100"
                                    :step="1"
                                    class="ma-4"
                                    label="% Avance"
                                    thumb-label="always"
                                    hide-details>
                                   
                                </v-slider>                                
                            </v-col>
                        </v-row>                    
                    </v-container>
                </v-card-text>
            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal = false" >
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" :loading="loading" @click.native="guardar()" >
                    <v-icon>done</v-icon>
                    {{ update ? "Actualizar" : "Guardar" }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    components: {        

    },

    data: () => ({
        menu1:false,
        menu2:false,
        proyectos:[],
        usuarios_cliente:[],
        usuarios_super:[],
        loadingclientes:false,
        loadingusuarios:false,
        loadingusers:false,
        clientes:[],
        registros:[],
        fab: false,
        name: "datagrid",
        importData: [],
        columns: [            
            "nombre_proyecto",
            "cliente.identificador",
            "cliente.nombre",            
            "usuario_asignado.nombre",            
            "fecha_inicial",
            "fecha_cierre",
            "estatus",
            "avance",
            "actions"
        ],
        show_loading: true,
        options: {
            filterable: [
                "nombre_proyecto",
                "cliente.identificador",
                "cliente.nombre",            
                "usuario_asignado.nombre",            
                "fecha_inicial",
                "fecha_cierre",
                "avance",
                "estatus",
            ],
            sortable: [
                "nombre_proyecto",
                "cliente.identificador",
                "cliente.nombre",            
                "usuario_asignado.nombre",            
                "fecha_inicial",
                "fecha_cierre",
                "avance",
                "estatus",
            ],

            headings: {
                "nombre_proyecto":"Proyecto",            
                "cliente.identificador":"RFC Cliente",
                "cliente.nombre":"Cliente",                
                "usuario_asignado.nombre":"Usuario Asignado",                
                "fecha_inicial":"Fecha Inicial",
                "fecha_cierre":"Fecha Cierre",
                "estatus":"Estatus",
                "avance":"Avance",
                actions: "Operaciones"
            },
            listColumns: {                
                estatus: [{
                        id: "Abierto",
                        text: "Abierto"
                    },
                    {
                        id: "Cerrado",
                        text: "Cerrado"
                    },
                    {
                        id: "En progreso",
                        text: "En progreso"
                    },                    
                ],
                tipo_servicio:[],
            }
        },

        URL: "",
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Service Desk",
                disabled: true,
                to: ""
            },
            {
                text: "Proyectos",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        title: "",
        modal: false,
        update: false,
        pagination: {
            sortBy: "clave"
        },
        search: "",                
        arr_estatus:["Abierto","Cerrado","En progreso"],
        model: {
            id_proyecto:"",
            tipo:"Proyecto", //Ticket|Proyecto
            nombre_proyecto:"",
            cliente:"",
            usuario_asignado:"",
            notas:"",
            fecha_inicial:null,
            fecha_cierre:null,
            estatus:"Abierto",
            avance:0,
        },        
        rules: {
            required: v => !!v || "Este campo es requerido",
            rfclen: v =>
                (v && v.length >= 9) || "RFC debe tener al menos 9 caractéres",
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Correo electrónico no valido";
            },
            anio: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            }
        },                
        camposexcel: {
            "Proyecto":"nombre_proyecto",  
            "RFC Cliente":"cliente.identificador",
            "Cliente":"cliente.nombre",            
            "Usuario Asignado":"usuario_asignado.nombre",            
            "Fecha Inicial":"fecha_inicial",
            "Fecha Cierre":"fecha_cierre",
            "Estatus":"estatus",
            "Avance":"avance",
        },                       
       
    }),
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.registros;
            }

        },
    },
    methods: {
        validaFecha: function(fecha) {
            if (fecha == "Invalid date")
                return "Fecha no válida."
            else
                return true;
        },
        validaDias: function() {
            if (this.model.fecha_inicial != "" && this.model.fecha_cierre != "") {
                var inicio = moment(this.model.fecha_inicial, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_cierre, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Cierre no debe ser menor a la Fecha Inicial."                
            }
            return true;
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();                
                this.update = false;                
            } else {                
                this.update = true;
            }
            this.modal = true;
        },

        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
            this.model.tipo="Proyecto";            
            this.model.estatus = "Abierto";
            this.model.fecha_inicial = null;
            this.model.fecha_cierre = null;
            this.model.avance = 0;    
            this.model.fecha_inicial = moment().format("YYYY-MM-DD");        
            var usuarios_id = this.usuarios_super.map(e => e.id_usuario);                    
            if(this.$local_storage.get('id_usuario',0) != 0 && usuarios_id.includes(parseInt(this.$local_storage.get('id_usuario')))) {                
                this.model.usuario_asignado = parseInt(this.$local_storage.get('id_usuario'));
            }            
            
        },      

        guardar() {
            const datos = this.model;

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var metodo = "post";
                var urlCliente = this.$hostname + "catalogos/proyectos/";
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id_proyecto + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                        this.cargar();                        
                        this.modal = false;
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos. Intente nuevamente por favor."
                            //showConfirmButton: false,
                        });
                        console.log(error);
                        this.cargar();                                               
                    });
            }
        },

        cargar: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let filtros = {
                filtros:{
                    "tipo":"Proyecto"
                }
            }
            axios
                .post(this.$hostname + "catalogos/proyectos/get_data/", filtros)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.registros = res.data;                        
                    }
                })
                .catch(err => {
                    console.log(err);                    
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        },

        getRegistro: function (id_registro) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.$hostname + "catalogos/proyectos/" + id_registro + "/")
                .then(response => {
                    this.model = response.data;
                    this.getUsuariosCliente(1); 
                    this.openModal(2); //ACTUALIZAR                                          
                }).catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        }, //getRegistro

        deleteRegistro: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value){
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios
                    .delete(this.$hostname + "catalogos/proyectos/" + id_registro + "/")
                    .then(response => {                        
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente.",                            
                            footer: ""
                        });
                    })
                    .catch(error => {                        
                        var footer = "";
                        if(error.response.data && error.response.data.toString().includes("ProtectedError")){                            
                            footer = "El Proyecto no se puede eliminar porque se encuentra relacionado a uno o más Tickets. Favor de verificar";
                        }
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro",
                            footer: footer
                        });
                    }).then(()=>{
                        this.cargar();
                    });
                }                    
            });
        },
        getNombreCliente: function(item){
            return item.identificador+" - "+item.nombre;
        },
        getNombreUsuario: function(item){
            return item.nombre+" "+item.apellidos;
        },
        cargarClientes: async function () {
            this.loadingclientes = true;
            await axios
                .get(this.$hostname + "clientes/get_clientes/")
                .then(response => {
                    this.clientes = response.data.filter(e => e.estatus == true);                    
                }).catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los clientes.",
                        footer: ""
                    });
                }).then(() => {
                    this.loadingclientes = false;
                });
        },
        getUsuariosCliente: async function (abrir_modal=0) {
            if(this.model.cliente && this.model.cliente!=null && this.model.cliente!=""){
                if(abrir_modal == 0){//Solo si está buscando se vacía, cuando se carga desde getRegistro se deja el que traiga el modelo
                    this.model.usuario_cliente = "";
                }
                this.loadingusuarios = true;
                let data = {
                    cliente: this.model.cliente,
                    sistema: this.$sistema
                };

                await axios.post(this.$hostname + "usuarios/obtener_usuarios_cliente/", data)                    
                    .then(response => {
                        this.usuarios_cliente = response.data.filter(e => e.estatus == true);                         
                    }).catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener los usuarios del cliente seleccionado.",
                            footer: "Intente nuevamente por favor"
                        });
                    }).then(() => {
                        this.loadingusuarios = false;
                    });
            }            
        },

        getUsuarios: function () {
            this.loadingusers = true;
            axios
                .get(this.$hostname + "usuarios/")
                .then(response => {
                    this.usuarios_super = response.data.filter(function (usuario) {
                        return usuario.id_usuario > 0 && usuario.nombre!="SFTP" && usuario.tipo_usuario == 6 && usuario.estatus == true; //Solo super usuarios activos
                    });  
                    
                    this.usuarios_super = this.usuarios_super.sort(function (a, b) {
                        return a.nombre > b.nombre ? 1 : -1;
                    });                      
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los usuarios.",
                        footer: ""
                    });
                })
                .then(() => {
                    this.loadingusers = false;
                });
        },
        getTiposServicios: function() {
            axios.get(this.$hostname + "catalogos/tipos_servicios/get_tipos/")
                .then(response => {
                    this.tipos_servicio = response.data.filter(e => e.activo == 1);
                    this.tipos_servicio = this.tipos_servicio.sort(function (a, b) {
                        return a.nombre > b.nombre ? 1 : -1;
                    });
                    this.tipos_servicio.forEach(e => {
                        this.options.listColumns.tipo_servicio.push({"id":e.nombre,"text":e.nombre});
                    });
                    
                })
                .catch(error => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los tipos de servicios.",
                    footer: ""
                });
            });
        },
        
        
        
    }, //methods
    created: function () {
        this.cargarClientes();
        this.getUsuarios();     
        this.getTiposServicios();  
        this.cargar();
    }
};
</script>
